module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Frontbmatterbheads"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbChapterbtitle"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("Culinary Stencils")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbChapterbtitle"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("Using Edible Dusts")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec1"
    }
  }, [_vm._v("METALLIC LUSTRE DUSTS")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec2"
    }
  }, [_vm._v("MATT DUSTS")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#sec3"
    }
  }, [_vm._v("MULTICOLOUR MATT DUSTS")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbChapterbtitle"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("Using Royal Icing")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#sec4"
    }
  }, [_vm._v("ON COOKIES")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#sec5"
    }
  }, [_vm._v("ON CUPCAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#sec6"
    }
  }, [_vm._v("ON THE TOPS OF BOARDS AND CAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#sec7"
    }
  }, [_vm._v("ON THE SIDES OF CAKES")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#sec8"
    }
  }, [_vm._v("MULTICOLOUR EFFECTS")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbChapterbtitle"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("Adjusting a Stencil to Fit")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbChapterbtitle"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("Adding Embellishments")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbChapterbtitle"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("Making Your Own Stencil")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm#sec9"
    }
  }, [_vm._v("USING READILY AVAILABLE MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbmiscbhead"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm#sec10"
    }
  }, [_vm._v("USING SPECIALIST TOOLS")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOCbChapterbtitle"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("Other Uses for Stencils")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/2-1.jpg"
    }
  }), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "P_CAPbimage"
  }, [_vm._v("Stacked Hatboxes"), _c('br'), _vm._v("The beautiful, intricate patterns on these boxes are created simply using culinary stencils, royal icing and edible dusts.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 60
// module chunks = 0